module.exports = __webpack_public_path__ + "static/media/qrnew.c1ab4704.png";